import React, {useState} from 'react';
import {compose} from "redux";
import PopoverCustom from "../../../../theme/CustomElements/PopoverCustom";
import {Grid, withStyles} from "@material-ui/core";
import CustomButton from "../../../../theme/CustomElements/CustomButton";
// import CustomInput from "../../../../theme/CustomElements/CustomInput";
// import returnIcon from "../../../../images/request/return.svg";
import {withTranslation} from "react-i18next";
import {MONTSERRAT} from "../../../../constants/fontCss";
import {
    ARCHIVED,
    COMMERCIALLY_FOLLOWED_UP_STATUS,
    TO_BE_INVOICED_STATUS,
    TO_SCHEDULE_STATUS, WAITING_FOR_REPLY,
    WAITING_VIDEOS_PHOTOS,
    XS
} from "../../../../constants/constants";
import {customRenderShowBtnAction} from "../constantRequestPage";
// import BookmarkIcon from "../../../../images/request/archive.svg";
import {useSelector} from "react-redux";
import SaveIcon from "@material-ui/icons/Save";
import goFilterIcon from "../../../../images/request/Groupe 9099.svg";
import archiveIcon from "../../../../images/request/Groupe 9100.svg";
import allIcon from "../../../../images/request/Groupe 9130.svg";

const styles = (theme) => ({
    popoverEditStatus: {
        background: '#fff',
        boxShadow: '0px 0px 20px rgba(0, 0, 254, 0.05)',
        borderRadius: 10,
        minWidth: 200,
        maxWidth: 400,
        [theme.breakpoints.down(XS)]: {
            maxWidth: 'calc(100vw - 20px)'
        }
    },
    headerEditStatus: {
        background: '#001529',
        boxShadow: '0px 0px 20px rgba(0, 0, 254, 0.05)',
        borderRadius: '10px 10px 0px 0px',
        color: '#fff',
        fontWeight: 600,
        padding: '0.5rem',
    },
    contentEditStatusWrapper: {
        padding: '0.5rem',
        width: '100%',
        '& .btnActionEdit': {
            margin: '5px 10px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            width: 'fit-content',
            minWidth: 170,
            maxWidth: '100%',
            padding: '4px 16px',
            borderRadius: 8,
            background: 'transparent',
            border: '1px solid transparent',
            '&:hover':{
                background: '#ebf2f8',
            },
            '&.activeChooseBtn': {
                background: '#DDDDFF',
                '& div':{
                    fontWeight: 600
                }
            },
            '& .iconWrapper':{
                display: 'flex',
                alignItems: 'center',
            },
            '& svg': {
                width: 20,
                '& path': {
                    fill: '##0000fe !important'
                }
            },
            '& .titleIcon': {
                paddingLeft: 8,
                color: '#0000fe',
                textTransform: 'uppercase',
                lineHeight: 1.1,
                fontWeight: 500,
            }
        },
        '& .btnAction':{
            padding: 10,
            display: 'flex',
            justifyContent: 'center'
        }
    },
    btnResponse: {
        background: '#0000FF !important',
        borderRadius: 10,
        '& .MuiButton-label': {
            fontFamily: MONTSERRAT,
            fontWeight: 700,
            fontSize: '0.875rem'
        }
    }
});

const PopoverEditActionStatusArchiveRepeat = (props) => {
    const {
        anchorEl, popoverAriaOwns, onClose, classes, formValuePopover, t
    } = props;
    // const dataUser = useSelector((state) => state.authReducer.dataUser);
    const currentStatus = (formValuePopover?.status?.statusType?.code) ?? "";
    const [value, setValue] = useState(currentStatus);
    // const [loading, setLoading] = useState(false);
    return (<PopoverCustom
        anchorEl={anchorEl}
        popoverAriaOwns={popoverAriaOwns}
        onClose={onClose}
        content={
            <div className={classes.popoverEditStatus}>
                <div className={`${classes.headerEditStatus} headerEditStatus`}>
                    {t("request.list.id")}: {formValuePopover.id}
                </div>
                <div className={`${classes.contentEditStatusWrapper} contentEditStatusWrapper`}>
                    {currentStatus !== WAITING_VIDEOS_PHOTOS && customRenderShowBtnAction({
                        className: `btnActionEdit ${value === WAITING_VIDEOS_PHOTOS ? "activeChooseBtn" : ""}`,
                        onClick: () => setValue(WAITING_VIDEOS_PHOTOS),
                        icon: goFilterIcon,
                        title: t("request.status.WAITING_VIDEOS_PHOTOS")
                    })}
                    {currentStatus !== WAITING_FOR_REPLY && customRenderShowBtnAction({
                        className: `btnActionEdit ${value === WAITING_FOR_REPLY ? "activeChooseBtn" : ""}`,
                        onClick: () => setValue(WAITING_FOR_REPLY),
                        icon: goFilterIcon,
                        title: t("request.status.TO_PROCESS")
                    })}
                    {currentStatus !== COMMERCIALLY_FOLLOWED_UP_STATUS && customRenderShowBtnAction({
                        className: `btnActionEdit ${value === COMMERCIALLY_FOLLOWED_UP_STATUS ? "activeChooseBtn" : ""}`,
                        onClick: () => setValue(COMMERCIALLY_FOLLOWED_UP_STATUS),
                        icon: goFilterIcon,
                        title: t("request.status.COMMERCIALLY_FOLLOWED_UP")
                    })}
                    {currentStatus !== TO_SCHEDULE_STATUS && customRenderShowBtnAction({
                        className: `btnActionEdit ${value === TO_SCHEDULE_STATUS ? "activeChooseBtn" : ""}`,
                        onClick: () => setValue(TO_SCHEDULE_STATUS),
                        icon: goFilterIcon,
                        title: t("request.status.TO_SCHEDULE")
                    })}
                    {/*{(formValuePopover.archivedByAdmin || formValuePopover.repeatAt) && customRenderShowBtnAction({*/}
                    {/*    className: `btnActionEdit ${value === UNARCHIVED_AND_NOT_REPEAT ? "activeChooseBtn" : ""}`,*/}
                    {/*    onClick: () => setValue(UNARCHIVED_AND_NOT_REPEAT),*/}
                    {/*    icon: goFilterIcon,*/}
                    {/*    title: t("request.status.unarchivedAndNotRepeat")*/}
                    {/*})}*/}
                    { !!(currentStatus !== TO_BE_INVOICED_STATUS && formValuePopover?.manager?.id) && customRenderShowBtnAction({
                        className: `btnActionEdit ${value === TO_BE_INVOICED_STATUS ? "activeChooseBtn" : ""}`,
                        onClick: () => setValue(TO_BE_INVOICED_STATUS),
                        icon: allIcon,
                        title: t("request.status.TO_BE_INVOICED")
                    })}
                    { currentStatus !== ARCHIVED  && customRenderShowBtnAction({
                        className: `btnActionEdit ${value === ARCHIVED ? "activeChooseBtn" : ""}`,
                        onClick: () => setValue(ARCHIVED),
                        icon: archiveIcon,
                        title: t("request.status.archived")
                    })}
                    <div className={"btnAction"}>
                        <CustomButton
                            className={classes.btnResponse}
                            title={t("button.save")}
                            onClick={() => {
                                if (typeof props.handleSave === "function") {
                                    props.handleSave(value)
                                }
                            }}
                            buttonProps={{
                                startIcon: <SaveIcon className={"iconAdd"}/>
                            }}

                        />
                    </div>
                </div>
            </div>
        }
    />)
}

export default compose(withStyles(styles), withTranslation())(PopoverEditActionStatusArchiveRepeat);
